// @flow
export const loginRoute = '/login';
export const mfaLoginRoute = `${loginRoute}/mfa`;
export const mfaDeviceRegistrationCompletedRoute = `${loginRoute}/mfa/registration-complete`;
export const resetPasswordRoute = '/password/reset';
export const createPasswordRoute = '/password/new';
export const updatePasswordRoute = '/password/update';
